import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-C9MHV5SMYQ';

export const initGA = () => {
  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }
};

export const logPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page_path: path });
};

export const logEvent = (action, category, label, value) => {
  ReactGA.event({
    action,
    category,
    label,
    value
  });
};

// Eventos específicos para imóveis
export const logImovelView = (imovelId, codigo) => {
  ReactGA.event({
    action: 'view_imovel',
    category: 'imoveis',
    label: codigo,
    value: imovelId
  });
};

export const logImovelSearch = (filters) => {
  ReactGA.event({
    action: 'search_imoveis',
    category: 'imoveis',
    label: JSON.stringify(filters)
  });
};

export const logLeadGenerated = (source) => {
  ReactGA.event({
    action: 'lead_generated',
    category: 'leads',
    label: source
  });
};

export const logContactForm = (imovelId) => {
  ReactGA.event({
    action: 'contact_form',
    category: 'imoveis',
    label: imovelId
  });
};

